import React from "react";
import LogoHeader from "../components/Header/LogoHeader";
import Footer from "../components/Footer/Footer";

// Layout: Header from MainLayout (LogoHeader) + two-column body like Search/Report layouts
// Props:
// - children: left/main content
// - sidebar: right column content (optional)
const KnowledgeHubLayout = ({ children, sidebar }) => {
  return (
    // Match MainLayout's outer container sizing to avoid unexpected horizontal scroll
    <div className="container-fluid flex flex-col bg-pl-bg justify-between min-h-screen">
      {/* Background bar behind fixed header */}
      <div className="fixed w-full bg-pl-bg border-b border-pl-border z-[90]" />

      {/* Fixed top header (same as MainLayout) */}
      <LogoHeader />

  {/* Main content area with left nav offset like search/report screens */}
  {/* Use percentage-based calc to prevent 100vw scrollbar-induced overflow */}
  <main className="mb-40 pt-[80px]">
        <div className="w-full max-w-6xl mx-auto px-4 md:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 w-full gap-6 md:gap-10">
            {/* Left/main column */}
            <div className="md:col-span-3 w-full flex flex-col justify-between h-full">
              {children}
            </div>

            {/* Right/sidebar column */}
            <div className="hidden md:block md:col-span-1 mt-0">
              {sidebar}
            </div>
          </div>
        </div>
      </main>


      {/* Footer (use component directly for consistent styling across pages) */}
      <Footer />
    </div>
  );
};

export default KnowledgeHubLayout;
